import { render, staticRenderFns } from "./CheckoutAddress.vue?vue&type=template&id=10f5380a&scoped=true&"
import script from "./CheckoutAddress.vue?vue&type=script&lang=js&"
export * from "./CheckoutAddress.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutAddress.vue?vue&type=style&index=0&id=10f5380a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f5380a",
  null
  
)

export default component.exports